import { Trans } from 'react-i18next';

import { OnboardingGuideConfig } from '@/components/OnboardingGuide/OnboardingGuide';
import { TextHighlight } from '@/components/OnboardingGuide/OnboardingGuide.styled';

import { Language } from '@/types/i18n';

export const ActivateAccountStepsConfig: OnboardingGuideConfig = {
  title: 'mobileAdoption.verifyOTP.activateAccount.title',
  steps: [
    {
      icon: {
        name: 'password',
      },
      renderText: (language: Language) => (
        <Trans
          i18nKey="mobileAdoption.verifyOTP.activateAccount.step1"
          lang={language}
          components={{
            a1: <TextHighlight />,
          }}
        />
      ),
    },
    {
      icon: {
        name: 'shield-check',
      },
      renderText: (language: Language) => (
        <Trans
          i18nKey="mobileAdoption.verifyOTP.activateAccount.step2"
          lang={language}
          components={{
            a1: <TextHighlight />,
            a2: <TextHighlight />,
          }}
        />
      ),
    },
    {
      icon: {
        name: 'phone-plus',
      },
      renderText: (language: Language) => (
        <Trans
          i18nKey="mobileAdoption.verifyOTP.activateAccount.step3"
          lang={language}
          components={{
            a1: <TextHighlight />,
            a2: <TextHighlight />,
          }}
        />
      ),
    },
    {
      icon: {
        name: 'check-fat-outline',
      },
      renderText: (language: Language) => (
        <Trans
          i18nKey="mobileAdoption.verifyOTP.activateAccount.step4"
          lang={language}
          components={{
            a1: <TextHighlight />,
          }}
        />
      ),
    },
  ],
};
